import { Link, Outlet } from "react-router";
import { useTranslation } from "react-i18next";
import { TodoPopover } from "../molecules/TodoPopover";
import UserNav from "../molecules/UserNav";
import LogoSmall from "../icons/LogoSmall";
import { MainNav } from "~/molecules/MainNav";
import GhostIcon from "~/icons/GhostIcon";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { featureFlags } from "~/config/featureFlags";
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { AdventCandlestick } from "~/molecules/AdventCandlestick";
import { TopNavSearch } from "~/molecules/TopNavSearch";
import { ValentineGift } from "~/molecules/ValentineGift";
import { EasterEgg } from "~/molecules/EasterEgg";
import { Midsommarstang } from "~/molecules/Midsommarstang";
import { GovernanceUnitSwitcher } from "~/molecules/GovernanceUnitSwitcher";

const TopNav = () => {
  const { t } = useTranslation();
  const isHalloweenThemeEnabled = useFeatureFlagEnabled(
    featureFlags.halloweenTheme,
  );

  return (
    <>
      <div className="bg-card h-16 border-b">
        <div className="container flex h-full items-center gap-2">
          <Link to="/">
            <LogoSmall height={32} width={32} />
          </Link>
          <MainNav />
          <div className="flex flex-1 justify-center">
            <TopNavSearch />
          </div>
          <div className="flex items-center gap-4">
            {isHalloweenThemeEnabled && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="cursor-help">
                    <GhostIcon className="animate-ghostlyFloat size-10" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{t(($) => $.commons.seasonal.halloween)}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
            <ValentineGift />
            <EasterEgg />
            <Midsommarstang />
            <AdventCandlestick />
            <GovernanceUnitSwitcher />
            <TodoPopover />
            <UserNav />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default TopNav;
